export class PayWayModel {
  pgw_shop_id: string;
  pgw_order_id: string;
  pgw_amount: string;
  pgw_authorization_type: string;
  pgw_success_url: string;
  pgw_failure_url: string;
  pgw_return_method: string;
  pgw_signature: string;
}

export class PayWayResult {
  pgw_result_code: string;
  pgw_trace_ref: string;
  pgw_order_id: string;
  pgw_signature: string;
  pgw_transaction_id: string;
  pgw_amount: string;
  pgw_installments: string;
  pgw_card_type_id: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PayWayModel.ts